var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-box"},[_c('h3',[_vm._v("欢迎"+_vm._s(_vm.isTeacher === 'teacher' ? '专家' : '管理员')+"登录")]),(_vm.isTeacher === 'teacher')?_c('teacher'):_c('school')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }